import { useLang } from '@/app/utils/useLang';

export type ImgSectionKey = 'img1' | 'img2' | 'img3' | 'img4';

interface ImgSectionConfigParams {
    key: ImgSectionKey;
}

export interface ImgSectionConfig {
    moduleText: string;
    sectionId: string;
    pc: string;
    h5: string;
}

export const imgSectionConfigs = (key: ImgSectionConfigParams): ImgSectionConfig => {
    const configMap = {
        img1: {
            moduleText: 'CoverSection1',
            sectionId: 'imgSection1',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761099516136-ydqb3m-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761117283541-htil1z-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97.jpg',
        },
        img2: {
            moduleText: 'CoverSection2',
            sectionId: 'imgSection2',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761099496602-t2rtmm-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761117297780-muc84t-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%972.jpg',
        },
        img3: {
            moduleText: 'CoverSection3',
            sectionId: 'imgSection3',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761732336633-z2xf3m-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97-3.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761732316606-tsjhg9-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97-3.jpg',
        },
        img4: {
            moduleText: 'CoverSection4',
            sectionId: 'imgSection4',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761117266156-win3lo-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761117318086-1mdqj9-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%973.jpg',
        },
    };

    return configMap[key] || {};
};

const getBaseConfig = (key: ImgSectionKey): ImgSectionConfig => {
    return imgSectionConfigs(key);
};

export function getCoverSectionConfig(key: ImgSectionKey) {
    const { moduleText, sectionId, pc, h5 } = getBaseConfig(key);
    const { t } = useLang(`${moduleText}`);
    return {
        label: t('label'),
        title: t.rich('title', {
            sup: (text: string) => <sup>{text}</sup>,
        }),
        desc: t('desc'),
        sectionId,
        pc,
        h5,
    };
}

export function getTcConfig() {
    const { t } = useLang('TC');
    return {
        defaultListLength: 18,
        list: new Array(18).fill(null).map((item, index) => ({
            title: t(`title${index}`),
        })),
    };
}
